import { create } from 'zustand';
import { Message } from '../components/chat/ChatMessageArea';
import { Topic } from '../components/chat/ChatInterface.v2';
import { AIModel } from '../utils/modelPreference';

/**
 * 聊天会话全局状态 - 路由切换时保持会话不丢失
 */
interface ChatSessionState {
  // 核心会话数据
  messages: Message[];
  currentTopic: Topic | null;
  historySessionId: string | null;
  isTopicCompleted: boolean;
  isModelLocked: boolean;
  selectedModel: AIModel;
  solutionButtonShown: Set<string>;
  topicCompletionStatus: Record<string, boolean>;

  // 右侧问题输入区状态
  questionMode: 'none' | 'select' | 'image' | 'text';
  imageAnalyzed: boolean;
  textAnalyzed: boolean;

  // 是否有已保存的会话（用于判断是否需要恢复）
  hasSession: boolean;

  // Actions
  saveSession: (state: Partial<Omit<ChatSessionState, 'hasSession' | 'saveSession' | 'clearSession'>>) => void;
  clearSession: () => void;
}

const initialMessages: Message[] = [
  {
    id: '1',
    role: 'assistant',
    content: '你好！我是AI数理化助手，可以帮你解决数学、物理、化学问题。请在问题输入区提交问题进行分析并开始对话。',
    timestamp: new Date(),
    messageType: 'text',
  },
];

export const useChatStore = create<ChatSessionState>()((set) => ({
  messages: initialMessages,
  currentTopic: null,
  historySessionId: null,
  isTopicCompleted: false,
  isModelLocked: false,
  selectedModel: 'deepseek' as AIModel,
  solutionButtonShown: new Set<string>(),
  topicCompletionStatus: {},
  questionMode: 'none',
  imageAnalyzed: false,
  textAnalyzed: false,
  hasSession: false,

  saveSession: (state) => set({ ...state, hasSession: true }),
  clearSession: () =>
    set({
      messages: initialMessages,
      currentTopic: null,
      historySessionId: null,
      isTopicCompleted: false,
      isModelLocked: false,
      solutionButtonShown: new Set<string>(),
      topicCompletionStatus: {},
      questionMode: 'none',
      imageAnalyzed: false,
      textAnalyzed: false,
      hasSession: false,
    }),
}));
